export const servicesData = [
    {
        Icon:'ri-quill-pen-line',
        NameFirst:'Website',
        NameLast:'Design',
        Describe:'I can design an integrated website responsive to all devices.'
    },
    {
        Icon:'ri-braces-line',
        NameFirst:'FrontEnd',
        NameLast:'Developer',
        Describe:'I can program websites professionally and with clean code that is easy for another programmer to read.'
    },
    {
        Icon:'ri-layout-4-line',
        NameFirst:'BackEnd',
        NameLast:'Developer',
        Describe:'I can edit and develop your site and add the things you want.'

    },
]

